"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const svgTemplates_1 = require("./svgTemplates");
function styleSvg() {
    const options = this;
    const svgContents = [];
    if (!options.svg_template)
        options.svg_template = [];
    options.svg_template.push({ content: svgContents });
    if (options.style in svgTemplates_1.styles) {
        options.svg_template.push({ content: svgTemplates_1.styles[options.style] });
    }
    return options;
}
exports.default = styleSvg;
